export default __webpack_public_path__ + "static/media/icon-user.612f53a9.svg";